import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = null as string | null;

const slice = createSlice({
  name: 'headerBrandImagePath',
  initialState,
  reducers: {
    setHeaderBrandImagePath: (state, action: PayloadAction<string>) => {
      return action.payload || null;
    },
  },
});

export const { setHeaderBrandImagePath } = slice.actions;

export default slice.reducer;
